import axios from 'axios'

const API_URL = '/api/contacts/'

// Create a new contact
const createContact = async (contactData) => {
	const response = await axios.post(API_URL, contactData)

	if (response.status === 201) {
		try {
			//const init = emailjs.init({ publickey: 'tzTCnypJ5MkbgA0Oe' })
			// emailjs.init({
			// 	publicKey: 'ye4P8Q5gJbjsVdDOvcLAg',
			// })

			const EMAILJS_URL = 'https://api.emailjs.com/api/v1.0/email/send'
			const PUBLIC_KEY = 'tzTCnypJ5MkbgA0Oe'
			const SERVICE_ID = 'service_ct6x18a'
			const TEMPLATE_ID = 'template_contact'

			const { firstName, lastName, email, phoneNumber, contactMethod, timeToContact, comments } =
				contactData

			const templateParams = {
				firstName,
				lastName,
				email,
				phoneNumber,
				contactMethod,
				timeToContact,
				comments,
			}
			const data = {
				service_id: SERVICE_ID,
				template_id: TEMPLATE_ID,
				user_id: PUBLIC_KEY,
				template_params: templateParams,
			}

			const emailResponse = axios.post(EMAILJS_URL, data)

			console.log('E-Mail sent successfully: ', emailResponse.status, emailResponse.data)
		} catch (error) {
			console.log('E-Mail could not be sent')
		}
	}

	return response.data
}

const contactService = {
	createContact,
}

export default contactService
